import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MacAddressRoutingModule } from './mac-address-routing.module';
import { MacAddressFormComponent } from './components/mac-address-form/mac-address-form.component';
import { OneWebComponentsAngularModule } from '@one/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { MacAddressResultModalComponent } from './modals/mac-address-result-modal/mac-address-result-modal.component';
import { PrintMacAddressResultComponent } from './modals/mac-address-result-modal/print-mac-address-result/print-mac-address-result.component';
import { NgxPrintModule } from 'ngx-print';
import { ErrorMessagePipe } from './pipes/error-message.pipe';
import { ModalService } from './services/modal.service';
import { SnackBarService } from './services/snackbar.service';


@NgModule({
  declarations: [
    MacAddressFormComponent,
    MacAddressResultModalComponent,
    PrintMacAddressResultComponent,
    ErrorMessagePipe
  ],
  imports: [
    CommonModule,
    MacAddressRoutingModule,
    NgxPrintModule,
    ReactiveFormsModule,
    OneWebComponentsAngularModule
  ],
  providers: [
    ModalService,
    SnackBarService
  ]
})
export class MacAddressModule { }
